import React, {useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {MainWrapper, Layout} from './HomePage.Styles';
import {Header} from './../../components/organisms/Header/Header';
import {StickyNavigationLink} from '../../components/organisms/StickyNavigationLinks/StickyNavigationLinks';
import {MainContent} from './../../components/organisms/MainContent/MainContent';
import {RightScan} from './../../components/organisms/RightScan/RightScan';

export const HomePage = () => {
  const [tag, setTag] = useState('');
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const searchQuery = searchParams.get('q');
    if (searchQuery) {
      setTag(searchQuery);
    }
  }, [searchParams]); 

  return (
    <Layout>
      <Header onSearch={setTag} />
      <StickyNavigationLink onSearch={(tag) => console.log(tag)} />
      <MainWrapper>
        <MainContent tag={tag} />
        <RightScan />
      </MainWrapper>
    </Layout>
  );
};